<template>
  <div class="guide pt-2 mb-5">
    <page-header :title="$t('scope.text_111')" />
    <a-alert type="info" show-icon>
      <template slot="message">{{$t('scope.text_112')}}<icon type="navbar-more" style="font-size: 15px;" />{{$t('scope.text_113')}}</template>
    </a-alert>
    <div class="env-items-wrap" v-for="env in ENVS" :key="env">
      <h2 class="mb-3">{{ ENV_TITLE[env] }}</h2>
      <div class="env-items d-flex flex-wrap" v-if="SUB_EBV_ITMS[env]">
        <div class="item d-flex p-2 mr-3 align-items-center" v-if="Object.keys(SUB_EBV_ITMS[env]).length > 1" :class="{ active: active(env)}" @click="allSelectItems(env)">
          <h5 class="flex-fill">{{$t('scope.text_114')}}</h5>
        </div>
        <template v-for="(item, k) of SUB_EBV_ITMS[env]">
          <a-tooltip :key="k" v-if="formatDisabled(env, k)" :title="disabledTitles[k]">
            <div class="item d-flex p-2 mr-3 align-items-center disabled">
              <img :src="item.logo" :style="item.logoStyle" />
              <h5 class="flex-fill">{{ item.name }}</h5>
            </div>
          </a-tooltip>
          <div v-else :key="k" class="item d-flex p-2 mr-3 align-items-center" :class="{ active: actives.indexOf(k) > -1 }" @click="handleItemClick(env, k)">
            <img :src="item.logo" :style="item.logoStyle" />
            <h5 class="flex-fill">{{ item.name }}</h5>
          </div>
        </template>
      </div>
    </div>
    <page-footer style="left:0">
      <div slot="right">
        <a-button :disabled="actives.length === 0" class="mr-3" type="primary" @click="handleNext">{{$t('scope.text_14')}}</a-button>
      </div>
    </page-footer>
  </div>
</template>

<script>
import * as R from 'ramda'
import get from 'lodash/get'
import { mapGetters } from 'vuex'
import { ENVS, ENV_TITLE, SUB_EBV_ITMS, CLOUDACCOUNT_ENVS } from './constants'
import { removeSetupInStorage } from '@/utils/auth'

export default {
  name: 'GuideIndex',
  data () {
    const TYPES = { ENVS, ENV_TITLE, SUB_EBV_ITMS }
    return {
      ...TYPES,
      disabledTitles: {
        baremetal: this.$t('scope.text_115'),
        lb: this.$t('scope.text_115'),
        k8s: this.$t('scope.text_116'),
      },
      actives: [],
    }
  },
  computed: {
    ...mapGetters(['isAdminMode']),
    globalSettingSetupKeys () {
      const { globalSetting } = this.$store.state
      if (globalSetting && globalSetting.value) {
        return globalSetting.value.setupKeys || []
      }
      return []
    },
  },
  watch: {
    globalSettingSetupKeys: {
      handler (keys = []) {
        this.actives = keys ? [...keys] : []
      },
      immediate: true,
    },
  },
  beforeDestroy () {
    removeSetupInStorage()
  },
  methods: {
    active (env) {
      const keys = Object.keys(this.SUB_EBV_ITMS[env])
      for (let i = 0; i < keys.length; i++) {
        const k = keys[i]
        if (this.actives.indexOf(k) === -1) {
          return false
        }
      }
      return true
    },
    formatDisabled (env, k) {
      if (k === 'k8s') {
        return R.difference(['onecloud', 'public', 'private'], this.actives).length === 3
      }
      if (['baremetal', 'lb'].indexOf(k) > -1) {
        return this.actives.indexOf('onestack') === -1
      }
      return false
    },
    allSelectItems (env) {
      const _actions = [...this.actives]
      if (_actions.indexOf(env) === -1) {
        _actions.push(env)
      }
      const keys = Object.keys(this.SUB_EBV_ITMS[env])
      const isAllActive = this.active(env)
      if (isAllActive) {
        _actions.splice(_actions.indexOf(env), 1)
      }
      for (let i = 0; i < keys.length; i++) {
        const k = keys[i]
        const index = _actions.indexOf(k)
        if (isAllActive) {
          _actions.splice(index, 1)
        } else if (index === -1) {
          _actions.push(k)
        }
      }
      this.linkageKeys(_actions)
      this.actives = _actions
    },
    handleItemClick (env, k) {
      const _actions = [...this.actives]
      const kIndex = _actions.indexOf(k)
      if (kIndex === -1) {
        _actions.push(k)
        if (_actions.indexOf(env) === -1 && k !== 'vmware') {
          _actions.push(env)
        }
      } else {
        _actions.splice(kIndex, 1)
        const keys = Object.keys(this.SUB_EBV_ITMS[env])
        if (env === 'private') {
          keys.splice(keys.indexOf('vmware'), 1)
        }
        let f = false
        for (let i = 0; i < keys.length; i++) {
          const k = keys[i]
          if (_actions.indexOf(k) > -1) {
            f = true
            break
          }
        }
        const envIndex = _actions.indexOf(env)
        if (!f && envIndex > -1) {
          _actions.splice(_actions.indexOf(env), 1)
        }
        this.linkageKeys(_actions)
      }
      this.actives = _actions
    },
    linkageKeys (actions) {
      if (actions.indexOf('onestack') === -1) {
        ['baremetal', 'lb', 'onecloud'].forEach(k => {
          const index = actions.indexOf(k)
          if (index > -1) {
            actions.splice(index, 1)
          }
        })
      }
      if (R.difference(['public', 'private', 'vmware'], actions).length === 3) {
        ['container', 'k8s'].forEach(k => {
          const index = actions.indexOf(k)
          if (index > -1) {
            actions.splice(index, 1)
          }
        })
      }
    },
    async getImagesInfo () {
      this.loading = true
      try {
        const { data = [] } = await new this.$Manager('imageutils', 'v1').get({
          id: 'imagesinfo',
        })
        return data
      } catch (error) {
        throw error
      } finally {
        this.loading = false
      }
    },
    async importedK8sImage () {
      try {
        const images = await this.getImagesInfo()
        if (!images || (images && images.length === 0)) {
          return false
        }
        const item = images.filter(item => {
          return item.id === 'images/shared/k8s-centos7-base.qcow2'
        })[0]
        if (item.imported === 'false' || !item.imported) {
          await new this.$Manager('images', 'v1').create({
            data: {
              name: item.name,
              copy_from: item.url,
              disk_format: item.format,
              is_public: true,
              protected: true,
              is_standard: true,
              properties: {
                os_type: item.type,
                os_arch: item.arch,
                os_description: item.distribution,
                os_distribution: item.distribution,
                os_version: item.version,
              },
            },
          })
        }
      } catch (err) {
        throw err
      }
    },
    async updateKeys () {
      try {
        await this.$store.dispatch('globalSetting/putFetchGlobalSettingValue', {
          setupKeys: this.actives,
        })
      } catch (err) {
        throw err
      }
    },
    async handleNext () {
      const _globalSettingSetupKeys = [...this.globalSettingSetupKeys]
      await this.updateKeys()
      if (this.actives.includes('k8s')) {
        this.importedK8sImage()
      }
      if (
        !_globalSettingSetupKeys.includes('onestack') &&
        this.actives.includes('onestack') &&
        !get(this.$store.state, 'globalSetting.value.setupOneStackInitialized', false)
      ) {
        this.$router.push({
          name: 'GuideCreate',
          query: {
            env: 'onecloud',
            key: 'onestack',
          },
        })
      } else {
        if (R.difference(CLOUDACCOUNT_ENVS, this.actives).length === CLOUDACCOUNT_ENVS.length) {
          this.$router.push('/vminstance')
        } else {
          this.$router.push('/cloudaccount')
        }
      }
    },
  },
}
</script>

<style lang="less">
@import "../../../src/styles/less/theme.less";
.guide {
  h2 {
    font-size: 14px;
    margin: 0;
  }
}
.guide .env-items .disabled{
  color: rgba(0,0,0,.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  text-shadow: none;
  box-shadow: none;
  cursor: not-allowed;
  &:hover {
    border-color:#d9d9d9;
    h5{
      color: rgba(0, 0, 0, 0.85);
    }
  }
}
.env-items-wrap{
  padding: 20px;
}
.env-items {
  .item {
    width: 120px;
    cursor: pointer;
    display: block;
    font-size: 14px;
    margin-bottom: 10px;
    border: 1px solid #eee;
    text-align: center;
    border-radius: 3px;
    box-sizing: border-box;
    &.active {
      border-color:@primary-color;
      h5{
        color:@primary-color;
      }
    }
    // &:hover {
    //   border-color:#4DA1FF;
    //   h5{
    //     color:#4DA1FF;
    //   }
    // }
    h5 {
      margin: 0;
      font-size: 13px;
      font-weight: 400;
    }
    img {
      height: 24px;
    }
  }
}
</style>
